import { object, string } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED, IS_VALID } from '@occc-app/lib/constants/validationMessages';

const schema = object({
  identifier: string({ required_error: IS_REQUIRED }).email(IS_VALID),
});

export const validate = makeValidate(schema);
